<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
  >
    <g
      id="Group_10819"
      data-name="Group 10819"
      transform="translate(-10874.36 -4547.546)"
    >
      <path
        id="Path_1"
        data-name="Path 1"
        d="M0,0H2.681V6.489L0,9.953Z"
        transform="translate(10881.302 4554.593)"
      />
      <path
        id="Polygon_1"
        data-name="Polygon 1"
        d="M7.761.812a1,1,0,0,1,1.479,0l6.236,6.846a1,1,0,0,1-.739,1.673H2.264a1,1,0,0,1-.739-1.673Z"
        transform="translate(10891.36 4556.877) rotate(180)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FilterIcon',
};
</script>
